
<template>
  <div ref="popup" class="popup-wrapper">
    <div class="popup-wrap" :class="{ fadeIn: fadeIn, fadeOut: fadeOut }">
      <div v-if="list && list.length && currIndex >= 0" class="popup-content">
        <img class="avatar" :src="list[currIndex].avatar" />
        <span class="text"
          >{{ list[currIndex].nick_name }}
          {{ list[currIndex].diff_time }} 购买成功！</span
        >
      </div>
    </div>
  </div>
</template>

<script lang='ts'>
import { Vue, Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import { diffTime } from '@lib/timer';

interface IItem {
  nick_name: string;
  diff_time: string;
  avatar: string;
  paid_time: string;
}
@Component({})
export default class Popup extends Vue {
  @Prop({ require: true }) id!: number;

  fadeIn = false;
  fadeOut = false;
  timer: any = null;
  refreshTimer: any = null;
  currIndex = -1;
  list: IItem[] = [];

  get listLen() {
    return this.list.length;
  }

  mounted() {
    this.getNoticeList();
    this.startScroll();
    this.setRefreshList();
  }

  setRefreshList() {
    this.refreshTimer = setInterval(this.getNoticeList, 600000); // 10分钟
  }

  async getNoticeList() {
    const { data } = await window.apis.getNoticeList({
      id: this.id,
    });
    this.handleCountDiff(data);
    this.list = [...data];
  }
  handleCountDiff(data: IItem[]) {
    const now = Number(new Date());
    data.forEach((item) => {
      const { second, minute } = diffTime(Number(new Date(item.paid_time)), now);
      if (minute < 1) {
        // 1分钟内，展示秒数
        item.diff_time = `${Number(second)}秒前`;
      } else {
        item.diff_time = `${Math.min(Number(minute), 5)}分钟前`;
      }
    });
  }

  startScroll() {
    this.animate();
    this.timer = setInterval(() => {
      this.animate();
    }, 2500);
  }
  stopScroll() {
    clearInterval(this.timer);
    clearInterval(this.refreshTimer);
    this.timer = null;
    this.refreshTimer = null;
  }
  beforeDestroy() {
    this.stopScroll();
  }

  animate() {
    if (this.currIndex === this.listLen - 1) {
      this.currIndex = 0;
    } else {
      this.currIndex++;
    }
    this.fadeIn = true;
    setTimeout(() => {
      this.fadeIn = false;
      this.fadeOut = true;
      setTimeout(() => {
        this.fadeOut = false;
      }, 400);
    }, 2000);
  }
}
</script>

<style lang="scss" scoped>
$policy-bg-color: #fda077;
$policy-active-bg-color: #ffece4;
$policy-text-color: white;

.popup-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100vw;
  height: 55px;
  background: rgba(0, 0, 0, 0.8);
  .popup-wrap {
    width: 100vw;
    height: 55px;
    transform: translateY(0px);
    opacity: 0;

    .popup-content {
      display: flex;
      // padding-left: 6px;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }

    &.fadeIn {
      opacity: 1;
      // transform: translateY(-5px);
      transition: all linear 400ms;
    }
    &.fadeOut {
      transform: translateY(-10px);
      opacity: 0;
      transition: all linear 400ms;
    }

    .avatar {
      width: 23px;
      height: 23px;
      margin-right: 8px;
      background-color: #f2f2f2;
      border-radius: 50%;
    }
    .text {
      color: #fff;
      font-size: 24px;
    }
  }
}
</style>
